import { getLocale } from "../runtime";

const da_couponcodelabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Indtast rabatkode`
};

const en_couponcodelabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Enter discount code`
};

const es_couponcodelabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Introducir código de descuento`
};

const fi_couponcodelabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Syötä alennuskoodi`
};

const nb_couponcodelabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Skriv inn rabattkode`
};

const sv_couponcodelabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ange rabattkod`
};

const couponcodelabel = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_couponcodelabel(inputs)
	if (locale === "en") return en_couponcodelabel(inputs)
	if (locale === "es") return es_couponcodelabel(inputs)
	if (locale === "fi") return fi_couponcodelabel(inputs)
	if (locale === "nb") return nb_couponcodelabel(inputs)
	if (locale === "sv") return sv_couponcodelabel(inputs)
	return "couponCodeLabel";
};

export { couponcodelabel as "couponCodeLabel" };